import { Outlet, Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import BasketLayout from '../../pages/layouts/basket-layout';
import { ApplicationRole } from '../../models/authentication/application-roles';

export const BasketRoute = () => {
    const { initialized, loading, authenticated, role } = useAuth();
    if (!initialized || loading) {
        return <div>Loading...</div>;
    }

    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    if (role === ApplicationRole.SupplierManager) {
        return <Navigate to="/admin" replace />;
    }

    if (role === ApplicationRole.OrderApprover) {
        return <Navigate to="/admin/approvals" replace />;
    }

    return (
        <BasketLayout>
            <Outlet />
        </BasketLayout>
    )
};